export default __webpack_public_path__ + "static/media/cr1me.0d14bcf7.png";